// removed by extract-text-webpack-plugin
module.exports = {"container":"container__g9QiG","sized":"sized__3j1m8","inner":"inner__21PkP","text":"text__3c3WB","emoji":"emoji__QJC8D"};


//////////////////
// WEBPACK FOOTER
// ./components/LookCloser/style.css
// module id = y6F2
// module chunks = 0